import { isWebSurveyRegistrationTypeEnabled } from '@/features/instrument-onboarding/lib/web-survey-registration-type'
import {
  isIndependentParty,
  isWebSurveySignup,
  type PromptProfile,
} from './nonQualifiedCampaignPrompt'

const PREFIX = 'sp_web_survey_ineligible_banner_dismissed'

export const WEB_SURVEY_INELIGIBLE_BANNER_MESSAGE =
  'You are not eligible for the current campaign, please stay tuned for more future surveys.'

function dismissKey(userId: string): string {
  return `${PREFIX}:${userId}`
}

function readRaw(key: string): string | null {
  if (globalThis.localStorage === undefined) return null
  try {
    return globalThis.localStorage.getItem(key)
  } catch {
    return null
  }
}

function writeRaw(key: string, value: string): void {
  if (globalThis.localStorage === undefined) return
  try {
    globalThis.localStorage.setItem(key, value)
  } catch {
    /* private mode / quota */
  }
}

export function isWebSurveyRegistrationTypeUiEnabled(): boolean {
  return isWebSurveyRegistrationTypeEnabled()
}

/** Hide SD-specific Home cards when flag is on and party is not Independent. */
export function shouldHideSdSurveysForRegistrationType(
  profile: PromptProfile | null | undefined,
  registrationTypeEnabled = isWebSurveyRegistrationTypeUiEnabled(),
): boolean {
  if (!registrationTypeEnabled || !profile) return false
  if (!isWebSurveySignup(profile)) return false
  return !isIndependentParty(profile.registeredPoliticalParty)
}

export function readWebSurveyIneligibleBannerDismissed(userId: string): boolean {
  return readRaw(dismissKey(userId)) === '1'
}

export function persistWebSurveyIneligibleBannerDismissed(userId: string): void {
  writeRaw(dismissKey(userId), '1')
}

export function clearWebSurveyIneligibleBannerDismissed(userId: string): void {
  if (globalThis.localStorage === undefined) return
  try {
    globalThis.localStorage.removeItem(dismissKey(userId))
  } catch {
    /* private mode */
  }
}

export function shouldShowWebSurveyIneligibleBanner(
  profile: PromptProfile | null | undefined,
  userId: string | undefined,
  registrationTypeEnabled = isWebSurveyRegistrationTypeUiEnabled(),
): boolean {
  if (!userId) return false
  if (!shouldHideSdSurveysForRegistrationType(profile, registrationTypeEnabled)) return false
  return !readWebSurveyIneligibleBannerDismissed(userId)
}
